module.exports = __webpack_public_path__ + "static/media/(V)_MG_5765_-_Cia_Termal_Beachewear_-_Moda_Feminina.db0c391f.jpg";